import { useEffect } from 'react';

/**
 * When the browser restores a page from the back-forward cache (e.g. the user
 * hits Back after logging out), React never remounts and the frozen JS state
 * still thinks the user is authenticated. This forces a fresh navigation to
 * home whenever a restored page no longer has a stored access token.
 */
export function useBfcacheAuthGuard() {
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted && !localStorage.getItem('accessToken')) {
        window.location.replace('/');
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);
}
